@if (pageComponent$ | async; as pageComponent) {
  <ng-container *ngComponentOutlet="pageComponent.component; inputs: pageComponent.inputs" />
}
